module.exports = __webpack_public_path__ + "img/8e54abb.png";